var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrlValid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.75 30.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#008d36;}.cls-2{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:0.7px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "url enged\u0151 akt\xEDv") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "enged\\u0151"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.38,
    cy: 15.37,
    r: 15.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.01 10.47 14.1 22.38 12.62 23.87 5.17 16.42 6.66 14.94 12.61 20.89 24.52 8.98 26.01 10.47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlValid);
export default __webpack_public_path__ + "static/media/url-valid.bab41931e0e6009d753c7486f865b97c.svg";
export { ForwardRef as ReactComponent };